import type { FaireThemeEntity } from "../../entity_types/theme";

export const spiritual_pocket_accents: FaireThemeEntity = {
  token: "spiritual-pocket-accents",
  type: "theme",
  name: "Spiritual Pocket Accents",
  description: "Enhance your crystal grids and display trays with affordable, high-vibration accents. These polished pieces are perfect for customers seeking small, tactile ways to connect with elemental energy.",
  teaser: "Shiva's Gift Shop already stocks various crystals like Amber and Smoky Quartz and offers Vedic & Shamanic practices, making these small spiritual tools a natural extension of your current inventory.",
  detail: "The 'Tiny Copper Spheres' in the payload are a highly affordable entry point into this category, aligning with your previous interests in spiritual stones and crystal healing.",
  bgColor: "#FFD4FF",
  tileBgColor: "#6b5831",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_tvg6phhz47",
    "p_9mjc7rd579",
    "p_8t8hvk8un7",
    "p_9myzne5heu",
    "p_vky92s65yd",
    "p_msxrt4k3yp",
    "p_vdx3dsq5nh",
    "p_hwqap8juzv",
    "p_v5rrdanusj",
    "p_nfxwfss734",
    "p_dq5y6p92q6",
    "p_yvdraembyp",
    "p_wheh6hhghd",
    "p_r24dmcvs3r",
    "p_p5sva8j7zs",
    "p_8asv5674yu",
    "p_er2r7rs8v8",
    "p_7rc37fu6kb",
    "p_mf4p5u8tvc",
    "p_s89fwf4z8b",
    "p_yekgpnugnw",
    "p_mr4sr2jgyz",
    "p_rnvd6szu7q",
    "p_5jphqn2suc",
    "p_4ymksyyeuu",
    "p_aa7ex4avg2",
    "p_a6dm6tkydx",
    "p_4qpolmb6l7",
    "p_5pq86hmwdz",
    "p_mzzckmkk2m",
    "p_cc5bu262g6",
    "p_w5kw3p5jxn",
    "p_s557stqyqr",
    "p_hvufrq4drq",
    "p_2m9mf2ae22",
    "p_5xk8558xgt",
    "p_b4gseerj59",
    "p_2q6fdd5t5p",
    "p_7usm72mgsp",
    "p_wps5dqa6cp",
    "p_4yuh4mwxld",
    "p_t73a882ktv",
    "p_nytyu2p8xf",
    "p_ttydgdnkbg",
    "p_659x7a8txz",
    "p_2r4v4zemax",
    "p_x5f3apc235",
    "p_kwunffq4rw",
    "p_t2rvm3gjh2",
    "p_v4he624zc8",
    "p_rsbw4dytdt",
    "p_4259dwah8y",
    "p_ywpbnhf8gf",
    "p_s4gmn5srsw",
    "p_4fsdwpk27z",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
